import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Ce qui se trouve dans l'ebook" className="bg-transparent" data-id="element-225" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px'
    }} data-id="element-226" data-mp="1c5gsduc5kjxu">
        <div className="text-center" data-id="element-227" data-mp="1c34atiab4blb">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-228" data-mp="1zut87d1zjq94">
            🌸 LE SYSTÈME K-SMART VISUEL™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-229" data-mp="24tcwhk41xe4n">
            Qu'allez-vous trouver à l'intérieur ?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-230" data-mp="1vsy7a9nyvevv">
            6 tomes complets · 120+ pages — Tout ce dont vous avez besoin en un seul endroit.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-231" data-mp="fhaoxaqyvxl5">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-232" data-mp="kby7yu37bzsc">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-233" data-mp="229q9p5pzlb2">
            📚 La Méthode des 6 Tomes
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="b0ldribai2za">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" data-id="element-235" data-mp="61scco9a22fh" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-236" data-mp="wtzhcujucgc1">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-237" data-mp="wvahmke2v5ye">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-238" data-mp="16q2h5tr802vt">
                  <span aria-hidden="true" data-id="element-239" data-mp="1bjyc0nc6t9mr">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-240" data-mp="1kjbnfljvg8a4">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-241" data-mp="1pi4zd9jifr86">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-242" data-mp="1ui179jvbw2t0">
            ✅ Chaque tome inclut
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-243" data-mp="3rb315uv9lu59">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-244" data-mp="406gtg7x5qa">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-245" data-mp="2dejjo0frag1t" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}